import { ResultStatus } from 'api/resultStatus';
import {
  SidebarStage,
  WorkflowEditorService,
  WorkflowStageDetail,
} from 'api-clients/monolith';
import React, { Dispatch, SetStateAction } from 'react';

import { DocumentSigningRuleProps } from 'containers/WorkflowEditor/components/Rules/DocumentSigningRules/types';
import { PartnerRuleProps } from 'containers/WorkflowEditor/components/Rules/PartnerRules/types';
import { RulesProps } from 'containers/WorkflowEditor/components/Rules/types';

type StageContextExtras = {
  stageLoadRevision?: number;
  openingExternalId?: string;
  submittedStageExtra?: WorkflowStageDetail['extra'];
  setStage: Dispatch<SetStateAction<WorkflowStageDetail>>;
  refetchStage: () => void;
  isDirty: boolean;
  isStageTitleDirty: boolean;
  setIsDirty: Dispatch<SetStateAction<boolean>>;
  rules: RulesProps;
  partnerRules: PartnerRuleProps;
  documentSigningRules: DocumentSigningRuleProps;
  setRules: Dispatch<SetStateAction<RulesProps>>;
  setPartnerRules: Dispatch<SetStateAction<PartnerRuleProps>>;
  setDocumentSigningRules: Dispatch<SetStateAction<DocumentSigningRuleProps>>;
  onSaveChanges: () => void;
  onDiscardChanges: () => void;
  funnelStages: SidebarStage[];
  resetUpdateStageResult: () => void;
  // Generic save-blocking hook for a stage's own settings panel to veto saving (e.g.
  // RehireCheckStage blocking save with zero configured HRIS connectors) without a Hire model
  // validation that would couple stage save to WX availability. Defaults to true; only a stage
  // type that needs this should ever call setCanSave(false).
  canSave: boolean;
  setCanSave: Dispatch<SetStateAction<boolean>>;
};

export type StageDetailResponse = Awaited<
  ReturnType<
    typeof WorkflowEditorService.getInternalApiWorkflowEditorFunnelsStages1
  >
>;

export type StageDetailPatchResponse = ResultStatus<
  WorkflowStageDetail,
  { errors: Record<string, Array<string>> }
>;

export type StageContextData = {
  stage: StageDetailResponse;
  updateStageResult: StageDetailPatchResponse;
} & StageContextExtras;

// Disabling because we know that we will use stage data only on the result 'ready' status.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const StageContext = React.createContext<StageContextData>(undefined!);
